import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { 
    Schedules_list, 
    Schedules_Datalist,
    Schedule_update,
    programValidate,
    adValidate,
    saveLinerPrograms,
    Schedules_Datalist_Ist,
    Schedule_update_weekly
} from "../../../api/api";
import { toast, ToastContainer } from "react-toastify";
import AdsInfo from "./components/adsInfo";
import _ from "lodash";
import ExpandView from "../scheduling-details/expand-view";
import ErrorPopup from "../../../component/popup/ErrorPopup";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { 
    fetchSchedule,
    update_schedule,
    confirmSaveAndUpdate,
} from "./utils/fetchAndUpdateScheduleAPI";
import { 
    searchProgram,
    addAdsOnClick,
    formatTime,
    generateTimeSlots,
    verifyMilliSeconds,
    millisecondsToHuman,
    calculateMinutes,
    millisecondsSinceMidnightUTC,
    getAssetInfo,
    selectedFiller,
    setAdsTime,
    setProgramTime,
    splitScheduleItems,
    pasteDataFun,
    trimPrograms,
} from "./utils/utils";
import { 
    handleDrop,
    addToDragabbleList,
} from "./utils/handleDrop";
import { 
    handleDragStart,
    handleDragOver,
    handleDragOver2,
    channelDragStart,
} from "./utils/handleDrag";
import { 
    handleProgramDelete,
    deleteEvent,
} from "./utils/handleDelete";
import { Left } from "./components/left/left";
import { SearchBar } from "./components/left/child-component/SearchBar";
import { ChannelListing } from "./components/left/child-component/ChannelListing";
import { AdsButton } from "./components/left/child-component/AdsButton";
import { Right } from "./components/right/Right";
import { DateNavigator } from "./components/right/child-component/DateNavigator";
import { ActionToolbar } from "./components/right/child-component/ActionToolbar";
import { ZoomableSchedule } from "./components/right/child-component/ZoomableSchedule";
import { ScheduleDetails } from "./components/right/child-component/ScheduleDetails";
import { SchedulingTable } from "./components/right/child-component/SchedulingTable";
import { DateActions } from "./components/right/child-component/child-component/DateActions ";
import { TableDetails } from "./components/right/child-component/child-component/TableDetails";
import { TableBody } from "./components/right/child-component/child-component/TableBody";
import { PanelLine } from "./components/right/child-component/child-component/PanelLine";
import { DraggableItem } from "./components/right/child-component/child-component/DraggableItem";
import { HoverLine } from "./components/right/child-component/child-component/HoverLine";
import { DraggableEvent } from "./components/right/child-component/child-component/DraggableEvent";
import { AdMarker } from "./components/right/child-component/child-component/AdMarker";
import { logDOM } from "@testing-library/react";
import { addadsSqId } from "./utils/utilityCommonMethods";
import { TotalScheduledDuration } from "./components/right/child-component/child-component/TotalScheduledDuration";
import { TimeSlot } from "./components/right/child-component/TimeSlot";
import useUndo from "use-undo";
import ellipse from "../../../assets/svg/scheduling/ellipse.svg";

function SchedulingDetailsNew () {

    const [programList, setProgramList] = useState();
    const [originalProgramList, setOriginalProgramList] = useState([]);
    const [promoList, setPromoList] = useState();
    const [fillerList, setFillerist] = useState();
    const [searchedText, setSearchedText] = useState("");
    // const [gridList, setGridList] = useState();
    const [
        gridListState,
        {
            set: setGridList,
            reset: resetGridList,
            undo: undoGridList,
            redo: redoGridList,
            canUndo,
            canRedo,
        },
    ] = useUndo([]);
    const { present: gridList } = gridListState;
    const [linePosition, setLinePosition] = useState(null);
    const [panelLinePosition, setPanelLinePosition] = useState(null);
    const [hoverTime, setHoverTime] = useState(null);
    const [panelHoverTime, setPanelHoverTime] = useState(null);
    const [panelHoverDate, setPanelHoverDate] = useState(null);
    const [draggableType, setDraggableType] = useState(null);
    const [zoomInOut, setZoomInOut] = useState(1);
    const [hoveredId, setHoveredId] = useState(null); 
    const [timeSlots, setTimeSlots] = useState([]);
    const [singleTimeSlots, setSingleTimeSlots] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [assetInfo, setAssetInfo] = useState(null);
    const [categoryTab, setCategoryTab] = useState("Ads");
    const [seqId, setSeqId] = useState(1);
    const [newGridData, setNewGridData] = useState([]);
    const [expandViewData, setExpandViewData] = useState([]);
    const [expendedViewDate, setExpendedViewDate] = useState('');
    const [copyData, setCopyData] = useState([]);
    const [loaderStatus, setLoaderStatus] = useState(false);
    const [errorbox, setErrorbox] = useState(false);
    const [eventTrim, seteventTrim] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [saveBtnValue, setSaveBtnValue] = useState("Save & Publish");
    const [startDate, setStartDate] = useState("");
    const locationState = useLocation();
    const navigate = useNavigate();
    const [weeklyView, setWeeklyView] = useState(false);
    const [weeklyViewLoopData, setWeeklyViewLoopData] = useState([]);
    const [editDisable, setEditDisable] = useState(true);
    const [editableTime, setEditableTime] = useState(new Date().getTime() + (1 * 60 * 60 * 1000));
    const {
        appThemeReducer: { appTheme },
    } = useSelector((state) => state);
    const draggedItem = useRef();
    const headerRef = useRef(null);
    const contentRef = useRef(null);
    
    const SaveAndUpdate = (btnType) => {
        confirmSaveAndUpdate (
            btnType,
            setLoaderStatus,
            gridList,
            saveLinerPrograms,
            locationState,
            toast,
            today,
            confirmPublishWithDate,
        )
    }

    const trimProgramsBlankSpace = (panelDate) => {
        trimPrograms(
            panelDate,
            gridList,
            setGridList,
        )
    }

    const pasteDataFunc = (panelDate) => {
        pasteDataFun (
            panelDate,
            gridList,
            copyData,
            setGridList,
            setCopyData,
        )
    }

    const updateProgramTime = (e, programUuid, sequenceId, panelDate) => {
        setProgramTime(
            e, 
            programUuid, 
            sequenceId, 
            panelDate,
            gridList,
            toast,
            setPanelHoverTime,
            setPanelLinePosition,
            setPanelHoverDate,
            setGridList,
            setAssetInfo,
        )
    }

    const updateAdsTime = (e, adSqId, sequenceId, panelDate) => {
        setAdsTime(
            e, 
            adSqId, 
            sequenceId, 
            panelDate,
            gridList,
            setGridList,
            setAssetInfo,
            toast,
        )
    }

    const selectedFillers = (id, adSqId, sequenceId, panelDate) => {
        selectedFiller(
            id, 
            adSqId, 
            sequenceId, 
            panelDate,
            fillerList,
            gridList,
            setGridList,
            setAssetInfo,
        )
    }

    const toGetAssetInfo = (sequenceId, panelDate, isSplit) => {
        getAssetInfo(
            sequenceId, 
            panelDate, 
            isSplit,
            gridList,
            setAssetInfo,
            setSeqId,
            setShowPopup,
        )
    }

    const deleteAdEvent = (seqId, sequenceId, panelDate) => {
        deleteEvent(
            seqId,
            sequenceId,
            panelDate,
            gridList,
            setGridList,
            setAssetInfo,
        )
    }

    const programDelete = (event, uuid, panelDate) => {
        handleProgramDelete(
            event, 
            uuid,
            panelDate,
            gridList,
            setGridList,
            setShowPopup,
            setAssetInfo
        )
    }

    const handleDragOvers = (event, date) => {
        handleDragOver(
            event, 
            date,
            draggedItem,
            setDraggableType,
            setPanelHoverDate,
            setPanelLinePosition,
            setPanelHoverTime,
            setHoveredId,
            zoomInOut,
            setLinePosition,
            setHoverTime,
        )
    }

    const handleDragOvers2 = (event, id) => {
        handleDragOver2(
            event, 
            id,
            draggedItem,
            setDraggableType,
            setHoveredId,
            zoomInOut,
            setLinePosition,
            setHoverTime,
        ) 
    }

    const handleZoomIn = () => {
        setZoomInOut((prevZoom) => Math.min(prevZoom + 1, 25));
    };
    
    const handleZoomOut = () => {
        setZoomInOut((prevZoom) => Math.max(prevZoom - 1, 1));
    };

    const adAdsOnClick = (sequenceId, panelDate) => {
        addAdsOnClick(
            sequenceId, 
            panelDate,
            locationState,
            adValidate,
            toast,
            gridList,
            setAssetInfo,
            setGridList,
            millisecondsToHuman,
        )
    }

    const handleAdsAndProgramDrop = (event, panelDate, isPublished) => {
        handleDrop(
            event,
            panelDate,
            setHoveredId,
            setLinePosition,
            draggedItem,
            setPanelHoverTime,
            setPanelLinePosition,
            setPanelHoverDate,
            panelHoverTime,
            gridList,
            toast,
            setGridList,
            adValidate,
            hoverTime,
            newGridData,
            millisecondsToHuman,
            verifyMilliSeconds,
            setHoverTime,
            programValidate,
            locationState,
            editableTime,
            isPublished
        )
    }

    const searchPrograms = (text) => {
        searchProgram(
            text,
            originalProgramList,
            setProgramList,
            setSearchedText,
        )
    }

    const updateLinearData = (panelDate) => {
        update_schedule(
            panelDate,
            gridList,
            Schedule_update,
            locationState,
            toast,
            today,
            setLoaderStatus,
            newGridData,
            Schedule_update_weekly,
            startDate,
            fetchLinearData,
        );
    }
    
    const fetchLinearData = (startDateUTC, endDateUTC, setDate) => {
        fetchSchedule(
            setLoaderStatus, 
            locationState, 
            Schedules_list, 
            setProgramList,
            setOriginalProgramList,
            setFillerist,
            setPromoList,
            Schedules_Datalist,
            Schedules_Datalist_Ist,
            setGridList,
            startDateUTC,
            endDateUTC,
            setDate,
            setWeeklyView,
            setWeeklyViewLoopData
        );
        setStartDate(startDateUTC);
    }

    const today = () => {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        const start = new Date(date);
        start.setDate(date.getDate() - 1);
        
        const end = new Date(date);
        end.setDate(date.getDate() + 6);
        
        // Format: YYYY-MM-DD
        const formatDate = (d) => {
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        
        const startDateFormatted = formatDate(start);
        const endDateFormatted = formatDate(end);

        fetchLinearData(startDateFormatted, endDateFormatted, 7);
    }

    const programZoomLevel = () => {
        const categoryPriority = {
            "Music": 20,
            "Entertainment": 5,
            "Kids": 15,
            "News & Opinion": 5,
            "Health & Fitness": 5,
            "Devotional": 3,
            "Short Films": 4,
            "Web Series": 5,
        };
        const categories = locationState?.state?.categories || [];

        if (!categories.length) return;
        const sorted = categories.sort((a, b) => {
            return (categoryPriority[b] || 0) - (categoryPriority[a] || 0);
        });
        const topCategory = sorted[0];
        setZoomInOut(categoryPriority[topCategory] || 1);
    }
    
    useEffect(()=> {
        today();
    },[locationState])

    useEffect(() => {
        const observer = new MutationObserver((mutationsList, observer) => {
            const targetElement = document.getElementById('targetOnTime');
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
                observer.disconnect(); // Stop observing once element is found
            }
        });

        // Start observing the body for child list changes
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true,  // Observe all descendants
        });

        // Cleanup the observer on component unmount
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const slots = generateTimeSlots();
        setTimeSlots(slots);
        setSingleTimeSlots(slots);
        programZoomLevel();
    }, []);

    useEffect(() => {
        splitScheduleItems(
            gridList,
            _, 
            setNewGridData,
        );
        const hasEditEnabled = gridList?.some(item => item.isEdit);
        localStorage.setItem("isLinearEdit", JSON.stringify(hasEditEnabled));
    },[gridList])

    useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.ctrlKey && e.key === 'z') {
            e.preventDefault();
            if (canUndo) undoGridList();
          }
      
          if ((e.ctrlKey && e.key === 'y') || (e.ctrlKey && e.shiftKey && e.key === 'z')) {
            e.preventDefault();
            if (canRedo) redoGridList();
          }
        };
      
        window.addEventListener('keydown', handleKeyDown);
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, [canUndo, canRedo, undoGridList, redoGridList]);

    useEffect(() => {
        const interval = setInterval(() => {
        setEditableTime(new Date().getTime() + (1 * 60 * 60 * 1000));
        }, 60000);
        return () => clearInterval(interval);
    }, []);
    
    const handlecategoryTab = (tab) => {
        setCategoryTab(tab);
    };

    const closePopup = () => {
        setEditDisable(true);
        setShowPopup(false);
    };

    const errorboxclose = () => {
        setErrorbox(false);
    }

    const copyDataFun = (panelDate) => {
        const copyObject = gridList.find(item => item.date === panelDate);
        if (copyObject) {
            setCopyData(copyObject?.scheduleItems);
        } else {
            toast.error("No match found.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
        }
    }

    const trim_programs_space = ((date) => {
        if (date) {
            setErrorMessage(`Are you sure you want to trim the spaces in '${new Date(date).toLocaleDateString("en-US", { weekday: "short",month: "short",day: "2-digit", })}'`)
        } else {
            setErrorMessage(`Are you sure you want to trim the spaces between all the scheduled programs?`)
        }
        setErrorbox(true);
        seteventTrim(() => () => trimProgramsBlankSpace(date))
    })

    const confirmPublishWithDate = (date) => {        
        if (date) {
            setErrorMessage(`Are you sure you want to publish the programs for '${new Date(date).toLocaleDateString("en-US", { weekday: "short",month: "short",day: "2-digit", })}' date?'`)
        } else {
            setErrorMessage(`Are you sure you want to publish all ready programs for their dates?`)
        } 
        setErrorbox(true);
        seteventTrim(() => async() => {
            // await SaveAndUpdate("Save")
            updateLinearData(date)
        })
    }

    const handelProgramDoubleClick = () => {

    }

    const prevWeekFunc = () => {
        if (locationState.state.gridList) {
            // let pageIndex = 0
            // const today = new Date();
            // today.setHours(0, 0, 0, 0);
            // const todayEpoch = today.getTime();

            // // Filter past dates only, descending order
            // const pastDays = weeklyViewLoopData
            //     .filter(d => d.date < todayEpoch)
            //     .sort((a, b) => b.date - a.date);

            // // Paginate (8 per page)
            // const start = pageIndex * 8;
            // const sliced = pastDays.slice(start, start + 8).reverse(); // Chronological order

            // // Pad with empty objects if needed
            // while (sliced.length < 8) {
            //     sliced.unshift({
            //     date: null,
            //     published: false,
            //     scheduleItems: [],
            //     isEdit: false
            //     });
            // }

            // setGridList(sliced);
            
        } else {
            const newStartDate = new Date(startDate);
            newStartDate.setDate(newStartDate.getDate() - 7);
            const start = newStartDate.toISOString().split("T")[0];
    
            const newEndDate = new Date(startDate);
            newEndDate.setDate(newEndDate.getDate());
            const end = newEndDate.toISOString().split("T")[0];
    
            fetchLinearData(start, end, 7);
        }
    }

    const nextWeekFunc = () => {
        if (locationState.state.gridList) {
            // let pageIndex = 0
            // const today = new Date();
            // today.setHours(0, 0, 0, 0);
            // const todayEpoch = today.getTime();

            // // Filter future and today dates, ascending order
            // const futureDays = weeklyViewLoopData
            //     .filter(d => d.date >= todayEpoch)
            //     .sort((a, b) => a.date - b.date);

            // // Paginate (8 per page)
            // const start = pageIndex * 8;
            // const sliced = futureDays.slice(start, start + 8);

            // // Pad with empty objects if needed
            // while (sliced.length < 8) {
            //     sliced.push({
            //     date: null,
            //     published: false,
            //     scheduleItems: [],
            //     isEdit: false
            //     });
            // }

            // return sliced;
            
        } else {
            const newStartDate = new Date(startDate);
            newStartDate.setDate(newStartDate.getDate() + 7);
            const start = newStartDate.toISOString().split("T")[0];
        
            const newEndDate = new Date(start);
            newEndDate.setDate(newEndDate.getDate() + 7);
            const end = newEndDate.toISOString().split("T")[0];
        
            fetchLinearData(start, end, 7);
        }
    }
    
    const updateModalData = (programInfo) => {
        const updatedGridList = gridList.some(item => item.date === programInfo?.panelDate)
        ? gridList.map(item =>
            item.date === programInfo?.panelDate
                ? {
                    ...item,
                    scheduleItems: item.scheduleItems.some(si => si.uuid === programInfo?.uuid)
                        ? item.scheduleItems.map(si => 
                            si.uuid === programInfo?.uuid ? programInfo : si
                        )
                        : [...item.scheduleItems, programInfo]
                }
                : item
        )
        : [...gridList, { date: programInfo?.panelDate, published: false, scheduleItems: [programInfo], isEdit: false }];
        addadsSqId(
            updatedGridList,
            programInfo?.panelDate,
            setGridList,
            millisecondsToHuman,
            locationState
        )
        setEditDisable(true);
        setShowPopup(false);
    }

    const expand = (e, panelDate) => {
        const redirectPage =  "/linear-expand-view";
        const data = locationState?.state;
        
        if (localStorage.getItem("isLinearEdit") === "true") {
            e.preventDefault(); // Prevent redirection
            setErrorMessage("Are you sure you want to leave this page without saving your changes?");
            setErrorbox(true);
            seteventTrim(() => async() => {
                localStorage.setItem("isLinearEdit", JSON.stringify(false));
                navigate(redirectPage, {
                    state: {
                        channelId: data?.channelId,
                        channelName: data?.channelName,
                        type: data?.type,
                        defaultFiller: data?.defaultFiller,
                        permission: data?.permission,
                        channelAssembly: data?.channelAssembly,
                        panelDate: panelDate,
                    }
                });
            })
        } else {
            navigate(redirectPage, {
                state: {
                    channelId: data?.channelId,
                    channelName: data?.channelName,
                    type: data?.type,
                    defaultFiller: data?.defaultFiller,
                    permission: data?.permission,
                    channelAssembly: data?.channelAssembly,
                    panelDate: panelDate,
                }
            });
        }
    }

    const setViewFunction = () => {
        if (locationState.state.gridList) {
            const redirectPage =  "/schedule-Loop";
            const data = locationState?.state;
            navigate(redirectPage, {
                state: {
                    channelId: data?.channelId,
                    channelName: data?.channelName,
                    type: data?.type,
                    defaultFiller: data?.defaultFiller,
                    permission: data?.permission,
                    channelAssembly: data?.channelAssembly,
                    gridList: gridList,
                    weeklyView: false
                }
            });
        } else {
            setWeeklyView(false);
        }
    }
    
    return (
        <>
            <div className={`content-body SchedulingDetail SchedulingLoop scheduling-loop-content-body ${appTheme}`}>
                <div className="dashboard-content flex schedule-loop-view">
                {
                    locationState?.state?.channelAssembly === "EXTERNAL" || 
                    weeklyView ?
                    ''
                    :
                    <Left>
                        <SearchBar appTheme={appTheme} searchedText={searchedText} searchPrograms={searchPrograms} />
                        <ChannelListing programList={programList} promoList={promoList} fillerList={fillerList} locationState={locationState} channelDragStart={channelDragStart} handelProgramDoubleClick={handelProgramDoubleClick} draggedItem={draggedItem} />
                        <AdsButton locationState={locationState} draggedItem={draggedItem} channelDragStart={channelDragStart} />
                    </Left>
                }
                    <Right customStyle={{width: locationState?.state?.channelAssembly === "EXTERNAL"? "100%": "100%", height: "782px", minHeight: "100vh", border: weeklyView && "none"}} weeklyView={weeklyView}>
                        <div className="top-content d-flex align-items-start">
                            <DateNavigator locationState={locationState} prevWeekFunc={prevWeekFunc} startDate={startDate} nextWeekFunc={nextWeekFunc} today={today} weeklyView={weeklyView} fetchLinearData={fetchLinearData} setViewFunction={setViewFunction} />
                            {
                                locationState?.state?.channelAssembly === "EXTERNAL" ||
                                weeklyView ?
                                ""
                                :
                                <ActionToolbar locationState={locationState} trim_programs_space={trim_programs_space} SaveAndUpdate={SaveAndUpdate} saveBtnValue={saveBtnValue} setSaveBtnValue={setSaveBtnValue} loaderStatus={loaderStatus} setWeeklyView={setWeeklyView} undoGridList={undoGridList} redoGridList={redoGridList} canUndo={canUndo} canRedo={canRedo} today={today} />
                            }
                        </div>
                        <div className="bottom-content mt-2 schedule-detail-container-scroll" style={{
                                // height: "100vh"
                                height: "87%",
                                position: "relative"
                            }}>
                            <div className="d-flex hide-scrollbar"
                                ref={headerRef}
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#1A1A1A",    
                                    zIndex: 9885,
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                }}
                                onScroll={(e) => {
                                    const scrollLeft = e.target.scrollLeft;
                                    if (contentRef.current) {
                                        contentRef.current.scrollLeft = scrollLeft;
                                    }
                                }}
                            >
                                <div className="middle-content">
                                    <ZoomableSchedule handleZoomIn={handleZoomIn} handleZoomOut={handleZoomOut} timeSlots={timeSlots} zoomInOut={zoomInOut} weeklyView={weeklyView}/>
                                </div>
                                {gridList?.length !== 0 &&
                                newGridData
                                    ?.map((item, key) => {
                                        if (key !== 0) {
                                            return (
                                                <div className="middle-content col-3 px-1 mb-2" style={{height: `${((weeklyView ? 70 : 145))}px`, width: weeklyView? "13%": "15rem"}}>
                                                    <div className="border-middle-container rounded" style={{ padding: "5px" }}>
                                                        <ScheduleDetails weeklyView={weeklyView}>
                                                            <DateActions item={item} confirmPublishWithDate={confirmPublishWithDate} copyData={copyData} pasteDataFunc={pasteDataFunc} copyDataFun={copyDataFun} trim_programs_space={trim_programs_space} expand={expand} locationState={locationState} weeklyView={weeklyView} />
                                                            {
                                                                weeklyView?
                                                                <TotalScheduledDuration millisecondsToHuman={millisecondsToHuman} item={item} />
                                                                :
                                                                <TableDetails appTheme={appTheme} item={item} millisecondsToHuman={millisecondsToHuman} />
                                                            }
                                                        </ScheduleDetails>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                            <div 
                                className="d-flex hide-scrollbar"
                                ref={contentRef}
                                style={{ overflow: "auto" }}
                                onScroll={(e) => {
                                    const scrollLeft = e.target.scrollLeft;
                                    if (headerRef.current) {
                                        headerRef.current.scrollLeft = scrollLeft;
                                    }
                                }}
                            >
                                <div className="middle-content" style={{height: `${(30*timeSlots.length*zoomInOut + 20)}px`}}>
                                    <TimeSlot handleZoomIn={handleZoomIn} handleZoomOut={handleZoomOut} timeSlots={timeSlots} zoomInOut={zoomInOut} weeklyView={weeklyView}/>
                                </div>
                                {gridList?.length !== 0 &&
                                newGridData
                                    ?.map((item, key) => {
                                        if (key !== 0) {
                                            return (
                                                <div className="middle-content col-3 px-1" style={{height: `${(30*timeSlots.length*zoomInOut + (weeklyView ? 20 : 10))}px`, width: weeklyView? "13%": "15rem"}}>
                                                    <div className="border-middle-container rounded" style={{ padding: "5px" }}>
                                                        <SchedulingTable weeklyView={weeklyView}>
                                                            <TableBody item={item} handleDragStart={handleDragStart} draggedItem={draggedItem} handleDragOvers={handleDragOvers} handleAdsAndProgramDrop={handleAdsAndProgramDrop}>
                                                                <div className="grid-list-container col-12 p-2 d-flex justify-content-center" style={{height: `${(30*timeSlots.length*zoomInOut)}px`, position: 'relative'}}>
                                                                    {panelLinePosition !== null && panelHoverDate === item?.date && (draggableType === "programs" || draggableType === "draggable-list") && (
                                                                        <PanelLine panelLinePosition={panelLinePosition} panelHoverTime={panelHoverTime} />
                                                                    )}
                                                                    {item?.length !== 0 ?
                                                                        item?.scheduleItems?.map((data, index) => {
                                                                            const midnight = new Date(item?.date);
                                                                            midnight.setHours(0, 0, 0, 0);
                                                                            const prev = item?.scheduleItems[index - 1];
                                                                            let hasGap = false;
                                                                            let gapDuration = 0;
                                                                            if (prev) {
                                                                                if (prev?.endAt < data?.startAt) {
                                                                                    hasGap = true;
                                                                                    gapDuration = data?.startAt - prev?.endAt; 
                                                                                }
                                                                            } else if (index === 0 && data?.startAt > midnight.getTime()) {
                                                                                hasGap = true;
                                                                                gapDuration = data?.startAt - midnight.getTime(); 
                                                                            }                                                                            
                                                                            return (
                                                                                <>
                                                                                    {hasGap && 
                                                                                    <>
                                                                                        <span className="gap-indicator" 
                                                                                        style={{
                                                                                                top: `${calculateMinutes(millisecondsSinceMidnightUTC(prev?.endAt? prev?.endAt : midnight.getTime()))*zoomInOut}px`,
                                                                                                width: `${weeklyView? "100%":"88%"}`,
                                                                                                // height: "3px",
                                                                                                height: calculateMinutes(gapDuration)*zoomInOut,
                                                                                                left: `${weeklyView? "0%":"12%"}`,
                                                                                                backgroundColor: "#9BA3AF4D",
                                                                                                borderStyle: "dashed",
                                                                                                borderWidth: "0px 3px 0px 3px",
                                                                                                borderColor: "#D22F26B2", 
                                                                                                position: "absolute",
                                                                                                zIndex: `${data?.sequence + 1}`,
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                            }}
                                                                                        >
                                                                                            <span
                                                                                                style={{
                                                                                                    position: "relative",
                                                                                                    left: `${weeklyView? "0px":"-28px"}`,
                                                                                                    height: "2px",
                                                                                                    width: "14%",
                                                                                                    background: "#D22F26",
                                                                                                }}
                                                                                                
                                                                                            >
                                                                                                <img 
                                                                                                    src={ellipse}
                                                                                                    width={16}
                                                                                                    style={{
                                                                                                        background: "#D22F26",
                                                                                                        borderRadius: "10px",
                                                                                                        position: "relative",
                                                                                                        top: "-10px",
                                                                                                        left: `${weeklyView? "15px":"0px"}`
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                         </span>
                                                                                    </>
                                                                                    }
                                                                                    <DraggableItem handleDragOvers2={handleDragOvers2} data={data} calculateMinutes={calculateMinutes} millisecondsSinceMidnightUTC={millisecondsSinceMidnightUTC} zoomInOut={zoomInOut} weeklyView={weeklyView}>
                                                                                        {linePosition !== null && hoveredId === data?.uuid && (draggableType === "fillers" || draggableType === "ads" || draggableType === "promos") && (
                                                                                            <HoverLine linePosition={linePosition} hoverTime={hoverTime} />
                                                                                        )}      
                                                                                        {
                                                                                            !weeklyView &&
                                                                                            <AdMarker data={data} calculateMinutes={calculateMinutes} zoomInOut={zoomInOut} />
                                                                                        }
                                                                                        <DraggableEvent data={data} toGetAssetInfo={toGetAssetInfo} item={item} locationState={locationState} index={index} calculateMinutes={calculateMinutes} zoomInOut={zoomInOut} newGridData={newGridData} key={key} formatTime={formatTime} programDelete={programDelete} weeklyView={weeklyView} isPublished={item?.published} editableTime={editableTime} />
                                                                                    </DraggableItem>  
                                                                                </>
                                                                            )
                                                                        })
                                                                        :
                                                                        <td colspan="5" class="text-center no-data">
                                                                            No data has been scheduled.
                                                                            {/* Nothing scheduled yet */}
                                                                        </td>
                                                                    }
                                                                </div>
                                                            </TableBody>
                                                        </SchedulingTable>  
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </Right>
                </div>
                <AdsInfo
                    show={showPopup}
                    handleClose={closePopup}
                    assetInfo={assetInfo}
                    millisecondsToHuman={millisecondsToHuman}
                    formatTime={formatTime}
                    appTheme={appTheme}
                    categoryTab={categoryTab}
                    handlecategoryTab={handlecategoryTab}
                    permission={locationState?.state?.permission}
                    selectedFillers={selectedFillers}
                    fillerList={fillerList}
                    updateAdsTime={updateAdsTime}
                    deleteAdEvent={deleteAdEvent}
                    toGetAssetInfo={toGetAssetInfo}
                    adAdsOnClick={adAdsOnClick}
                    programDelete={programDelete}
                    updateProgramTime={updateProgramTime}
                    verifyMilliSeconds={verifyMilliSeconds}
                    gridList={gridList}
                    setPanelHoverTime={setPanelHoverTime}
                    setPanelLinePosition={setPanelLinePosition}
                    setPanelHoverDate={setPanelHoverDate}
                    locationState={locationState}
                    updateModalData={updateModalData}
                    adValidate={adValidate}
                    setEditDisable={setEditDisable}
                    editDisable={editDisable}
                    promoList={promoList}
                    editableTime={editableTime}
                />
            </div>
            <ToastContainer />
            {
                loaderStatus &&
                <div className="loader-container">
                    <div className="loader"></div>
                    <p></p>
                </div>
            }
            { errorbox &&
                <ErrorPopup
                    btntext={"Yes"}
                    message={errorMessage}
                    closebox={() => errorboxclose()}
                    overrides={() => eventTrim()}
                />
            }
        </>    
    )
}

export default SchedulingDetailsNew;